import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";

import { PageNotFoundComponent } from "./page-not-found.component";
import {
  SiLoginPageComponent,
  SiResetPasswordComponent,
  SiInviteUserComponent,
  SiLogoutPageComponent,
  SiLandingPageComponent,
} from "@strategic-insights/ng-login-page-kc";
import { SiCustomerAccessComponent } from "./si-customer-access/si-customer-access.component";
import { SiKeyCloakLoginComponent } from "./shared/si-keycloak-redirect/si-keycloak-login/si-keycloak-login.component";
import { SiKeyCloakLogoutComponent } from "./shared/si-keycloak-redirect/si-keycloak-logout/si-keycloak-logout.component";
import { SiKeyCloakSSOComponent } from "./shared/si-keycloak-redirect/si-keycloak-sso/si-keycloak-sso.component";

import { AuthGuard } from "./auth.guard";
import { SiCustomerAccessGuard } from "./si-customer-access.guard";
import { UnAuthorizedUserComponent } from "./unauthorized-user.component";
import { AuthTokenGuard } from "./auth-token.gaurd";

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "/home",
    pathMatch: "full",
  },
  {
    path: "home",
    component: SiLandingPageComponent,
  },
  {
    path: "login",
    component: SiLoginPageComponent,
  },
  {
    path: "logout",
    component: SiLogoutPageComponent,
  },
  {
    path: "customerAccess",
    component: SiCustomerAccessComponent,
  },
  {
    path: "kcloginredirect",
    component: SiKeyCloakLoginComponent,
  },
  {
    path: "kclogoutredirect",
    component: SiKeyCloakLogoutComponent,
  },
  {
    path: "sso",
    component: SiKeyCloakSSOComponent,
  },
  {
    path: "verizon",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-verizon/si-customer-verizon.module"
      ).then((child) => child.SiCustomerVerizonModule),
    canLoad: [AuthGuard],
  },
  {
    path: "altice",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-altice/si-customer-altice.module"
      ).then((child) => child.SiCustomerAlticeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "windstream",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-windstream/si-customer-windstream.module"
      ).then((child) => child.SiCustomerWindstreamModule),
    canLoad: [AuthGuard],
  },
  {
    path: "vonage",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-vonage/si-customer-vonage.module"
      ).then((child) => child.SiCustomerVonageModule),
    canLoad: [AuthGuard],
  },
  {
    path: "ziply",
    loadChildren: () =>
      import("./si-customers/si-customer-ziply/si-customer-ziply.module").then(
        (child) => child.SiCustomerZiplyModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "yadkinvalley",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-yadkinvalley/si-customer-yadkinvalley.module"
      ).then((child) => child.SiCustomerYadkinvalleyModule),
    canLoad: [AuthGuard],
  },
  {
    path: "frontier",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-frontier/si-customer-frontier.module"
      ).then((child) => child.SiCustomerFrontierModule),
    canLoad: [AuthGuard],
  },
  {
    path: "allstream",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-allstream/si-customer-allstream.module"
      ).then((child) => child.SiCustomerAllstreamModule),
    canLoad: [AuthGuard],
  },
  {
    path: "armstrong",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-armstrong/si-customer-armstrong.module"
      ).then((child) => child.SiCustomerArmstrongModule),
    canLoad: [AuthGuard],
  },
  {
    path: "cox",
    loadChildren: () =>
      import("./si-customers/si-customer-cox/si-customer-cox.module").then(
        (child) => child.SiCustomerCoxModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "zoom",
    loadChildren: () =>
      import("./si-customers/si-customer-zoom/si-customer-zoom.module").then(
        (child) => child.SiCustomerZoomModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "bigriver",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bigriver/si-customer-bigriver.module"
      ).then((child) => child.SiCustomerBigriverModule),
    canLoad: [AuthGuard],
  },
  {
    path: "neustar",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-neustar/si-customer-neustar.module"
      ).then((child) => child.SiCustomerNeustarModule),
    canLoad: [AuthGuard],
  },
  {
    path: "neustar-2",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-neustar-2/si-customer-neustar-2.module"
      ).then((child) => child.SiCustomerNeustar2Module),
    canLoad: [AuthGuard],
  },
  {
    path: "midco",
    loadChildren: () =>
      import("./si-customers/si-customer-midco/si-customer-midco.module").then(
        (child) => child.SiCustomerMidcoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "intermedia",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-intermedia/si-customer-intermedia.module"
      ).then((child) => child.SiCustomerIntermediaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "firstcomm",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-firstcomm/si-customer-firstcomm.module"
      ).then((child) => child.SiCustomerFirstcommModule),
    canLoad: [AuthGuard],
  },
  {
    path: "granite",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-granite/si-customer-granite.module"
      ).then((child) => child.SiCustomerGraniteModule),
    canLoad: [AuthGuard],
  },
  {
    path: "coleman",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-coleman/si-customer-coleman.module"
      ).then((child) => child.SiCustomerColemanModule),
    canLoad: [AuthGuard],
  },
  {
    path: "atmc",
    loadChildren: () =>
      import("./si-customers/si-customer-atmc/si-customer-atmc.module").then(
        (child) => child.SiCustomerAtmcModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "nuso",
    loadChildren: () =>
      import("./si-customers/si-customer-nuso/si-customer-nuso.module").then(
        (child) => child.SiCustomerNusoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "saddleback",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-saddleback/si-customer-saddleback.module"
      ).then((child) => child.SiCustomerSaddlebackModule),
    canLoad: [AuthGuard],
  },
  {
    path: "unitifiber",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-unitifiber/si-customer-unitifiber.module"
      ).then((child) => child.SiCustomerUnitifiberModule),
    canLoad: [AuthGuard],
  },
  {
    path: "dnp",
    loadChildren: () =>
      import("./si-customers/si-customer-dnp/si-customer-dnp.module").then(
        (child) => child.SiCustomerDnpModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "accessone",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-accessone/si-customer-accessone.module"
      ).then((child) => child.SiCustomerAccessoneModule),
    canLoad: [AuthGuard],
  },
  {
    path: "digitalconnections",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-digitalconnections/si-customer-digitalconnections.module"
      ).then((child) => child.SiCustomerDigitalconnectionsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "zippytech",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-zippytech/si-customer-zippytech.module"
      ).then((child) => child.SiCustomerZippytechModule),
    canLoad: [AuthGuard],
  },
  {
    path: "coredial",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-coredial/si-customer-coredial.module"
      ).then((child) => child.SiCustomerCoredialModule),
    canLoad: [AuthGuard],
  },
  {
    path: "attmobility",
    loadChildren: () =>
      import("./si-customers/si-customer-att/si-customer-att.module").then(
        (child) => child.SiCustomerAttModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "mediacom",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-mediacom/si-customer-mediacom.module"
      ).then((child) => child.SiCustomerMediacomModule),
    canLoad: [AuthGuard],
  },
  {
    path: "nuwave",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-nuwave/si-customer-nuwave.module"
      ).then((child) => child.SiCustomerNuwaveModule),
    canLoad: [AuthGuard],
  },
  {
    path: "masergy",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-masergy/si-customer-masergy.module"
      ).then((child) => child.SiCustomerMasergyModule),
    canLoad: [AuthGuard],
  },
  {
    path: "dialpad",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-dialpad/si-customer-dialpad.module"
      ).then((child) => child.SiCustomerDialpadModule),
    canLoad: [AuthGuard],
  },
  {
    path: "s-net-comm",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-s-net-comm/si-customer-s-net-comm.module"
      ).then((child) => child.SiCustomerSNetCommModule),
    canLoad: [AuthGuard],
  },
  {
    path: "consolidatedcommunications",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-consolidatedCommunications/si-customer-consolidatedCommunications.module"
      ).then((child) => child.SiCustomerConsolidatedCommunicationsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "zoom",
    loadChildren: () =>
      import("./si-customers/si-customer-zoom/si-customer-zoom.module").then(
        (child) => child.SiCustomerZoomModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "sinch",
    loadChildren: () =>
      import("./si-customers/si-customer-sinch/si-customer-sinch.module").then(
        (child) => child.SiCustomerSinchModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "demo",
    loadChildren: () =>
      import("./si-customers/si-customer-demo/si-customer-demo.module").then(
        (child) => child.SiCustomerDemoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "brightspeed",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-brightspeed/si-customer-brightspeed.module"
      ).then((child) => child.SiCustomerBrightspeedModule),
    canLoad: [AuthGuard],
  },
  {
    path: "ibasis",
    loadChildren: () =>
      import(
        "./si-customers/si-customer-ibasis/si-customer-ibasis.module"
      ).then((child) => child.SiCustomerIBasisModule),
    canLoad: [AuthGuard],
  },
  {
    path: "rmicompanytest",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-rmicompanytest/si-customer-rmicompanytest.module"
      ).then((m) => m.SiCustomerRMICompanyTestModule),
    canLoad: [AuthGuard],
  },
  {
    path: "dpcompanywithrmi",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-dpcompanywithrmi/si-customer-dpcompanywithrmi.module"
      ).then((m) => m.SiCustomerdpCompanywithRMIModule),
    canLoad: [AuthGuard],
  },
  {
    path: "samltest",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-samltest/si-customer-samltest.module"
      ).then((m) => m.SiCustomerSamltestModule),
    canLoad: [AuthGuard],
  },
  {
    path: "rmi",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-rmi/si-customer-rmi.module"
      ).then((m) => m.SiCustomerRmiModule)
  },
  {
    path: "unauthorized",
    component: UnAuthorizedUserComponent,
  },
  {
    path: "resetPassword",
    component: SiResetPasswordComponent,
  },
  {
    path: "inviteUserForm",
    component: SiInviteUserComponent,
  },
  {
    path: "**",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-rmi/si-customer-rmi.module"
      ).then((m) => m.SiCustomerRmiModule),
    canLoad: [AuthGuard],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, { enableTracing: false, useHash: true }),
  ],
  declarations: [PageNotFoundComponent, UnAuthorizedUserComponent],
  exports: [RouterModule],
})
export class AppRoutingModule {}
